import { BROADCAST_NOTIFICATION_TYPE } from "@/entities/broadcast-notification";
import { useEventBusListener } from "@/modules/event-bus";

import { useObservationActionCommented } from "./observation-action-commented.hook";

const ObservationActionCommented = () => {
  const { runAction } = useObservationActionCommented();

  useEventBusListener(
    BROADCAST_NOTIFICATION_TYPE.OBSERVATION_COMMENTED,
    runAction
  );

  return <></>;
};

export default ObservationActionCommented;
